import React from 'react';

function Failed(props) {
  return (
    <div className="text-center mt-5 mb-5">Failed to load resource, Please retry after sometime or report to support</div>
  );
}
export default Failed;
